import { render } from "./index.vue?vue&type=template&id=3d07088a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/parts/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3d07088a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3d07088a', __exports__)) {
    console.log('reload')
    api.reload('3d07088a', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=3d07088a", () => {
    console.log('re-render')
    api.rerender('3d07088a', render)
  })

}


export default __exports__